import { useState } from "react";
import { toast } from "react-toastify";
import { useQuery, useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { FiHelpCircle } from "react-icons/fi";
import { AuthContext } from "../../../Context/AuthContext";
import PageHeader from "../../components/PageHeader";
import DataTable from "../../components/DataTable";
import Spinner from "../../../Spinner/Spinner";

const AdminFaqPage = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();
  const [form, setForm] = useState({ question: "", answer: "", category: "general", sortOrder: 0 });

  const { data, isLoading } = useQuery(
    "adminFaqs",
    async () => {
      const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/faq`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data.faqs || [];
    },
    { enabled: !!token }
  );

  const createMutation = useMutation(
    async (payload) => {
      const res = await axios.post(`${process.env.REACT_APP_SERVER_URL}/faq`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data;
    },
    { onSuccess: () => queryClient.invalidateQueries("adminFaqs") }
  );

  const deleteMutation = useMutation(
    async (id) => {
      await axios.delete(`${process.env.REACT_APP_SERVER_URL}/faq/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
    },
    { onSuccess: () => queryClient.invalidateQueries("adminFaqs") }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createMutation.mutateAsync(form);
      setForm({ question: "", answer: "", category: "general", sortOrder: 0 });
      toast.success("FAQ added");
    } catch (err) {
      toast.error(err.response?.data?.message || "Could not save FAQ");
    }
  };

  const columns = [
    { key: "question", label: "Question", render: (row) => row.question },
    { key: "category", label: "Category", render: (row) => row.category },
    {
      key: "actions",
      label: "",
      render: (row) => (
        <button
          type="button"
          className="dashboard-btn dashboard-btn--danger"
          onClick={() => deleteMutation.mutate(row._id)}
        >
          Delete
        </button>
      ),
    },
  ];

  return (
    <>
      <PageHeader title="FAQ" subtitle="Manage marketplace frequently asked questions" icon={FiHelpCircle} />
      <form className="dashboard-card" onSubmit={handleSubmit}>
        <h2 className="dashboard-card__title">Add FAQ</h2>
        <div className="dashboard-form-grid">
          <label className="dashboard-form-field dashboard-form-field--full">
            <span>Question</span>
            <input value={form.question} onChange={(e) => setForm((p) => ({ ...p, question: e.target.value }))} required />
          </label>
          <label className="dashboard-form-field dashboard-form-field--full">
            <span>Answer</span>
            <textarea rows={3} value={form.answer} onChange={(e) => setForm((p) => ({ ...p, answer: e.target.value }))} required />
          </label>
          <label className="dashboard-form-field">
            <span>Category</span>
            <input value={form.category} onChange={(e) => setForm((p) => ({ ...p, category: e.target.value }))} />
          </label>
        </div>
        <button type="submit" className="dashboard-btn dashboard-btn--primary" disabled={createMutation.isLoading}>
          Save FAQ
        </button>
      </form>
      {isLoading ? <Spinner /> : (
        <DataTable columns={columns} rows={(data || []).map((row) => ({ ...row, _key: row._id }))} />
      )}
    </>
  );
};

export default AdminFaqPage;
